import {
  ExamEventOverviewReportFilterSection,
  ExamEventOverviewReportPageHeader,
  ExamEventOverviewReportSummarySection,
  ExamEventOverviewReportList,
  ExamEventOverviewReportExportButton,
} from '@report/exam-event-overview-report';
import { APP_PERMISSIONS } from '@report/permission';
import { Flex, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function ExamEventOverviewReportPage() {
  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.EXAM_EVENT_OVERVIEW_REPORT.VIEW}>
      <Flex sx={{ flexDirection: 'column', minHeight: '100dvh' }}>
        <ExamEventOverviewReportPageHeader />
        <Flex sx={(theme) => ({ flexDirection: 'column', p: theme.spacing(6) })}>
          <PaperSection
            title='รายงานสรุปผลภาพรวมการสอบ'
            endAdornment={<ExamEventOverviewReportExportButton />}
          >
            <Flex
              sx={(theme) => ({
                gap: theme.spacing(6),
                p: theme.spacing(6),
                flexDirection: 'column',
              })}
            >
              <ExamEventOverviewReportFilterSection />
              <ExamEventOverviewReportSummarySection />
              <ExamEventOverviewReportList />
            </Flex>
          </PaperSection>
        </Flex>
      </Flex>
    </PermissionGuard>
  );
}
